<template>
  <div id="full-navbar">
    <b-navbar toggleable="md">
      <div class="container">
        <b-navbar-brand class="homapt-brand" to="/">
          <img @load="getNavbarHeight" src="../../static/YarlowLogo.svg" alt="logo" id="homapt-logo">
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown text="HomFAX" class="homapt-nav">
              <b-dropdown-item to="/home">Overview</b-dropdown-item>
              <b-dropdown-item to="/propertysearch">Claim Your House</b-dropdown-item>
              <b-dropdown-item to="/homfaxreport">HomFAX Report</b-dropdown-item>
              <!--<b-dropdown-item to="">My Home</b-dropdown-item> TODO: To home search if none, to property page if 1, to user dashboard if multiple -->
              <b-dropdown-item to="/faq">FAQ</b-dropdown-item>
            </b-nav-item-dropdown>
            <!--<b-nav-item-dropdown text="Realty" class="homapt-nav">
              <b-dropdown-item to="/propertysearch">Home Search</b-dropdown-item>
              <b-dropdown-item to="/realty">Selling</b-dropdown-item>
              <b-dropdown-item to="/rebates">HomApt Realty Rewards</b-dropdown-item>
            </b-nav-item-dropdown>-->
            <!--<b-nav-item class="homapt-nav homapt-nav-border" to="/marketplace">Marketplace</b-nav-item>-->
            <b-nav-item class="homapt-nav homapt-nav-border" to="/insights">Insights</b-nav-item>
            <b-nav-item class="homapt-nav homapt-nav-border" v-if="!getIdProvider" v-on:click="showModalLogin">Log In</b-nav-item>
            <b-nav-item class="homapt-nav" v-if="!getIdProvider" v-on:click="showModalSignUp"><span class="needs-border">Sign Up</span></b-nav-item>
            <b-nav-item-dropdown v-if="getIdProvider" class="homapt-nav" no-caret right>
              <template slot="button-content">
                <img @load="getNavbarHeight" v-bind:src="profileImage" alt="prof pic" id="profile-image">
                <p v-if="getNotificationNumber > 0" class="notification-number">{{ getNotificationNumber }}</p>
              </template>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'business'" to="/profile/business/dashboard">Dashboard <span v-if="getNotificationNumber > 0"> ({{ getNotificationNumber }})</span></b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'business'" to="/profile/business/details/overview">Details</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'business'" to="/profile/business/contacts">Contacts</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'business'" to="/profile/business/advertising">Advertising</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'business' && getIdProvider !== 'google'" to="/profile/business/security">Security</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'user'" to="/profile/user/dashboard">Dashboard <span v-if="getNotificationNumber > 0"> ({{ getNotificationNumber }})</span></b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'realtor'" to="/profile/realtor/dashboard">Dashboard <span v-if="getNotificationNumber > 0"> ({{ getNotificationNumber }})</span></b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'user'" to="/profile/user/details">Details</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'realtor'" to="/profile/realtor/details">Details</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'user'" to="/profile/user/pictures">Photos</b-dropdown-item>
              <!--<b-dropdown-item class="homapt-subnav" v-if="getUserType !== 'business'" to="/profile/user/alerts">Alerts</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType !== 'business'" to="/profile/user/wallet">Wallet</b-dropdown-item>-->
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'user'" to="/profile/user/profiles">Profiles</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'realtor'" to="/profile/realtor/subscriptions">Subscriptions</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType === 'realtor'" to="/profile/realtor/paymentinfo">Payment Info</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-if="getUserType !== 'business' && getIdProvider !== 'google'" to="/profile/user/security">Security</b-dropdown-item>
              <b-dropdown-item class="homapt-subnav" v-on:click="logOut">Log Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <the-auth-modal ref="authModal"></the-auth-modal>
    <b-alert show variant="warning" v-if="getUserType === 'business' && getCouponPaymentOverdue">{{ getPaymentFailureNotification }}</b-alert>
  </div>
</template>

<script>
import TheAuthModal from './authentication/TheAuthModal.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    theAuthModal: TheAuthModal
  },
  data () {
    return {
      navbarHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('user', [
      'getUserType',
      'getNotificationNumber'
    ]),
    ...mapGetters('realtor', [
      'getProfilePicture'
    ]),
    ...mapGetters('business', [
      'getCouponPaymentOverdue',
      'getPaymentFailureNotification'
    ]),
    profileImage () {
      if (this.getUserType === 'business') {
        if (this.$store.getters['business/getProfileImage']) {
          return this.$store.getters['business/getProfileImageUrl']
        } else {
          return '/static/defaultprofile.png'
        }
      }
      if (this.getUserType === 'user') {
        if (this.$store.getters['user/getProfileImage']) {
          return this.$store.getters['user/getProfileImageUrl']
        } else {
          return '/static/defaultprofile.png'
        }
      }
      if (this.getUserType === 'realtor') {
        if (this.$store.getters['realtor/getProfilePicture']) {
          return this.$store.getters['realtor/getProfilePicture']
        } else {
          return '/static/defaultprofile.png'
        }
      }
    }
  },
  methods: {
    ...mapMutations('loginModal', [
      'updateLoginMode'
    ]),
    showModalSignUp () {
      this.updateLoginMode(false)
      this.$refs.authModal.$refs.authModal.show()
    },
    showModalLogin () {
      this.updateLoginMode(true)
      this.$refs.authModal.$refs.authModal.show()
    },
    logOut () {
      this.$store.dispatch('logOut')
    },
    getNavbarHeight (event) {
      this.navbarHeight = document.getElementById('full-navbar').offsetHeight
      this.$emit('updateNavbarHeight', this.navbarHeight)
    }
  },
  mounted () {
    window.addEventListener('resize', this.getNavbarHeight)
    this.getNavbarHeight()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getNavbarHeight)
  }
}
</script>

<style scoped>
.dropdown-item {
  color: blue !important;
}

.homapt-nav {
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}

#homapt-logo {
  max-width: unset !important;
}

@media (max-width: 768px) {
  .homapt-nav, .homapt-subnav {
    text-align: center;
    width: 100%;
  }

  #homapt-logo {
    width: 80px;
  }
}

@media (min-width: 768px) {
  #homapt-logo {
    width: 100px;
  }
}

.container >>> .nav-link {
  color: #363E4A;
  font-size: 1rem;
}

@media (max-width: 1000px) {
  .container >>> .nav-link {
    font-size: 1.25rem;
  }
  .homapt-nav {
    padding-left: .5rem;
    padding-right: .5rem;
  }
}

.container >>> .dropdown-item:active {
  background-color: #feedaa;
  color: black;
}

.container >>> .dropdown-item.active {
  background-color: #feedaa;
  color: black;
}

.container >>> .dropdown-item:hover {
  background-color: #feedaa;
}

.container >>> .dropdown-menu {
  border-radius: 15px;
}

#profile-image {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  object-fit: cover !important;
}

.needs-border {
  padding: .6rem;
  border-style: solid;
  border-width: 2px;
  border-radius: 5%;
}

.notification-number {
  position: absolute;
  top: 0;
  right: 0;
  color: white !important;
  background-color: red;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue